import { Page } from "./page";

export class Home extends Page
{
    constructor() {
        super();
        this.title = "Homepage";
    }
}